import { GetStaticPaths, GetStaticProps } from "next";
import { loadPostFrontMatter, loadPostSource, postSlugs } from "../../lib/blog";
import { MDXRemote, MDXRemoteSerializeResult } from "next-mdx-remote";
import { Blog } from "../../components/blog";
import Image from "next/future/image";

interface Props {
  title: string;
  tags: string[];
  author: string;
  source: MDXRemoteSerializeResult;
}

export const getStaticProps: GetStaticProps<Props> = async (context) => {
  const slug = context?.params?.slug as string;

  const source = await loadPostSource(slug);
  const frontMatter = loadPostFrontMatter(slug);

  return {
    props: {
      title: frontMatter.title,
      tags: frontMatter.tags,
      author: frontMatter.author,
      source: source,
    },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: postSlugs.map((slug) => ({ params: { slug } })),
    fallback: false,
  };
};

const components = {
  // trunk-ignore(eslint/@typescript-eslint/no-explicit-any)
  img: (props: any) => (
    <Image
      alt="image for post"
      {...props}
      className="w-full sm:w-3/4 mx-auto rounded-2xl"
      sizes="50vw"
    />
  ),
};

export default function Post({ title, tags, author, source }: Props) {
  return (
    <>
      <Blog title={title} tags={tags} author={author}>
        <MDXRemote {...source} components={components} />
      </Blog>
    </>
  );
}
